var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3A34CD59-4CD1-4B38-A038-BC2A124F1493@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09.2----Profil-|-Vue-employ\\xE9-|-Dialog---Annuaire-chgt-compte",
    transform: "translate(-831.000000, -886.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(402.000000, 838.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotypes",
    transform: "translate(145.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Microsoft_logo",
    transform: "translate(284.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3F3F3",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F35325",
    x: 2.47835991,
    y: 2.47835991,
    width: 28.2824601,
    height: 28.2824601
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#81BC06",
    x: 33.23918,
    y: 2.47835991,
    width: 28.2824601,
    height: 28.2824601
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#05A6F0",
    x: 2.47835991,
    y: 33.23918,
    width: 28.2824601,
    height: 28.2824601
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFBA08",
    x: 33.23918,
    y: 33.23918,
    width: 28.2824601,
    height: 28.2824601
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo);
export default __webpack_public_path__ + "static/media/Microsoft_logo.53976323b76081957943b84b6c0a8c29.svg";
export { ForwardRef as ReactComponent };